/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { UtenteService } from '@shared/services/utente.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneUtenteRichiestaProfiloResolver implements Resolve<Observable<any>> {

    constructor(
        private anagraficaService: AnagraficaService,
        private utenteService: UtenteService,
    ) { }

    resolve(): Observable<any> {
        return forkJoin([
            this.anagraficaService.getEnte(),
            this.anagraficaService.getRuolo(),
            this.utenteService.getFromSession(),
        ]).pipe(
            map(([
                responseAnagraficaEnte,
                responseAnagraficaRuolo,
                responseUtenteSession,
            ]) => {
                return {
                    utenteSession: responseUtenteSession,
                    datalist: {
                        ente: responseAnagraficaEnte,
                        ruolo: responseAnagraficaRuolo,
                    },
                };
            }),
        );
    }

}